import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import BlogDetail from './pages/BlogDetail';
import Login from './pages/Login';
import './App.css';

// The editor pulls in TipTap and the syntax grammars — several hundred KB that
// readers never need. Split them out so only the author pays for them.
const Admin = lazy(() => import('./pages/Admin'));
const PostEditor = lazy(() => import('./pages/PostEditor'));
const Profile = lazy(() => import('./pages/Profile'));
const MyPosts = lazy(() => import('./pages/MyPosts'));

const RouteFallback = () => (
  <div style={{ padding: '80px 24px', textAlign: 'center', color: '#888' }}>Loading…</div>
);

function App() {
  return (
    <>
      <Navbar />
      <div className="app-main">
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/category/:categorySlug" element={<Home />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/my-posts" element={<MyPosts />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/new" element={<PostEditor />} />
            <Route path="/admin/edit/:id" element={<PostEditor />} />
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </>
  );
}

export default App;
